'use strict';

exports.__esModule = true;
var ARGUMENT = exports.ARGUMENT = 'ARGUMENT';
var ERROR = exports.ERROR = 'ERROR';
var NONE = exports.NONE = 'NONE';
var FINISH = exports.FINISH = 'FINISH';
var FINISH_ARGUMENT = exports.FINISH_ARGUMENT = 'FINISH_ARGUMENT';